module.exports = __webpack_public_path__ + "img/MonstersGuidetoShyness-Cover-1280.d032dafa.png";